<template>
  <div>
    <div class="d-flex align-center mb-2">
      <label v-if="label" :for="`${uid}-show`" class="label-input mb-0 mr-2">{{ label }}</label>
      <input
        :id="`${uid}-show`"
        type="checkbox"
        :checked="safeDivider.show"
        @change="e => updateDivider('show', !!e.target.checked)"
      />
    </div>
    <div v-if="safeDivider.show" :class="['group-item', wrapperClass]">
      <v-row>
        <v-col md="6" cols="12">
          <v-text-field
            type="number"
            suffix="px"
            :value="safeDivider.maxWidth"
            label="Max Width (px)"
            @input="value => updateDivider('maxWidth', normalizeNumber(value))"
          />
        </v-col>
        <v-col md="6" cols="12">
          <v-text-field
            type="number"
            suffix="px"
            :value="safeDivider.height"
            label="Height (px)"
            @input="value => updateDivider('height', normalizeNumber(value))"
          />
        </v-col>
        <v-col md="6" cols="12">
          <ColorPicker
            name="dividerPrimaryBackgroundColor"
            default-color="#5B04DE"
            :value="safeDivider.backgroundColor"
            label="Background Color"
            @input="value => updateDivider('backgroundColor', value)"
          />
        </v-col>
        <v-col md="6" cols="12">
          <v-select
            class="mt-2"
            :value="safeDivider.align"
            :items="['center', 'left', 'right']"
            label="Align"
            hide-details
            dense
            @change="value => updateDivider('align', value)"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import ColorPicker from './color-picker.vue';

const defaultDivider = {
  show: false,
  maxWidth: 200,
  height: 1,
  backgroundColor: '#E0E0E0',
  align: 'center',
};

export default {
  name: 'DividerPrimary',
  components: {
    ColorPicker,
  },
  props: {
    divider: {
      type: Object,
      required: true,
      default: () => ({ ...defaultDivider }),
    },
    label: {
      type: String,
      default: 'Divider Primary',
    },
    wrapperClass: {
      type: String,
      default: '',
    },
  },
  computed: {
    uid() {
      return `divider-primary-${this._uid}`;
    },
    safeDivider() {
      return { ...defaultDivider, ...(this.divider || {}) };
    },
  },
  methods: {
    updateDivider(key, value) {
      this.$set(this.divider, key, value);
      this.$emit('update:divider', this.divider);
      this.$emit('change', this.divider);
    },
    normalizeNumber(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num < 0) return 0;
      return num;
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
</style>
